<template>
    <div class="form-header">
        <div class="cookbook-wrapper">
            <img class="ta-magazine" src="/images/fr_multigift_carousel/ta-magazine.png" alt="magazine">
            <div>
                <h4><br><span>Merci, <br>
                    vous avez reçu <br>
                    votre e-book <br>
                    par email.</span></h4>
            </div>
        </div>
        <div class="thanks-cookbook">
            <h4>Continuez pour <br> recevoir votre cadeau <br> de bienvenue à €2 <br> <span>comme cet Airfryer</span></h4>
            <img class="pack-img" :src="form_side_image">
            <p>accédez à tous nos services et nos magazines</p>
        </div>


        <b-button class="button is-primary next-button" @click="nextStep()">Continuer</b-button>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>


</template>

<script>
import mixin from "../../../travel_step_mixin";
import {get} from "vuex-pathify";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";
import ScrollLink from "../../../../../../views/_commons/fr/ScrollLink.vue";
import image_mixin from "../../../../../../views/_commons/fr/mixins/image_mixin";

export default {
    mixins: [mixin,image_mixin],
    components:{ScrollLink},
}
</script>
